import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Layout, PageHeader } from "@/components/Layout";
import { fmtRM, formulaLabel } from "@/lib/format";
import { TrendingUp } from "lucide-react";

export default function PotentialInterest() {
  const [data, setData] = useState({ loans: [], totalPotentialInterest: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/reports/potential-interest").then((r) => setData(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <Layout>
      <PageHeader
        title="Potential Interest"
        subtitle="Expected interest from active loans over the next 30 days"
        action={
          <div className="bg-green-50 border border-green-200 rounded-lg px-5 py-2.5 flex items-center gap-3">
            <TrendingUp className="h-5 w-5 text-green-600" />
            <div>
              <div className="text-[11px] uppercase tracking-wide text-green-600">Total Next 30 Days</div>
              <div data-testid="potential-interest-total" className="font-mono-fig text-xl font-bold text-green-700">{fmtRM(data.totalPotentialInterest)}</div>
            </div>
          </div>
        }
      />

      <div className="bg-white border border-slate-200 rounded-lg shadow-sm overflow-x-auto">
        <table className="w-full text-sm" data-testid="potential-interest-table">
          <thead>
            <tr className="text-left text-xs uppercase tracking-wider text-slate-500 bg-slate-50">
              <th className="px-5 py-3 font-medium">Code</th>
              <th className="px-3 py-3 font-medium">Customer</th>
              <th className="px-3 py-3 font-medium">Formula</th>
              <th className="px-3 py-3 font-medium">Type</th>
              <th className="px-3 py-3 font-medium text-right">Outstanding</th>
              <th className="px-5 py-3 font-medium text-right">Expected Interest (30d)</th>
            </tr>
          </thead>
          <tbody>
            {data.loans.map((l) => (
              <tr key={l.code} data-testid={`interest-row-${l.code}`} className="border-b border-slate-50 hover:bg-slate-50">
                <td className="px-5 py-3"><Link to={`/loans/${l.code}`} className="font-mono-fig font-medium text-slate-900 hover:underline">{l.code}</Link></td>
                <td className="px-3 py-3 text-slate-700">{l.customerName}</td>
                <td className="px-3 py-3 font-mono-fig text-xs text-slate-500">{l.repaymentFormula || "—"}</td>
                <td className="px-3 py-3 text-slate-600 text-xs">{formulaLabel(l.formulaType)}</td>
                <td className="px-3 py-3 text-right font-mono-fig text-slate-800">{fmtRM(l.outstanding)}</td>
                <td className={`px-5 py-3 text-right font-mono-fig font-semibold ${l.expectedInterest > 0 ? "text-green-600" : "text-slate-400"}`}>{fmtRM(l.expectedInterest)}</td>
              </tr>
            ))}
            {!loading && data.loans.length === 0 && <tr><td colSpan={6} className="px-5 py-12 text-center text-slate-400">No active loans.</td></tr>}
          </tbody>
        </table>
      </div>
    </Layout>
  );
}
